import axios from 'axios';
import * as httpClient from './http-client';

export default {
  async obtenerAplicacion(customHostname) {
    const hostname = httpClient.processHostname(customHostname);
    const cacheKey = hostname === 'localhost' ? 'marca-blanca-web.development' : hostname;
    const config = {
      headers: {
        'Content-type': 'application/json',
      },
    };
    const res = await axios.get(
      `${process.env.RAZZLE_API_APLICACIONES}/auth/${cacheKey}`,
      config
    );
    return res.data;
  },
  async getOffices(applicationId, token) {
    return httpClient
      .getWithToken(
        `${process.env.RAZZLE_API_APLICACIONES}/aplicaciones-sucursales/aplicacion?aplicacionId=${applicationId}`,
        token
      )
      .then((res) => res.data);
  },
  async getAccionesAplicacion(applicationId, token) {
    return httpClient
      .getWithToken(
        `${process.env.RAZZLE_API_APLICACIONES}/acciones-aplicacion?aplicacionId=${applicationId}`,
        token
      )
      .then((res) => res.data);
  },
  async getMoneda(currencyId, token) {
    return httpClient
      .getWithToken(`${process.env.RAZZLE_API_APLICACIONES}/monedas/${currencyId}`, token)
      .then((res) => res.data);
  },
};
